import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Maine = () => {
  return (
    <StatePropertyTaxPage
      stateName="Maine"
      processDescription="How to submit an appeal: Abatement: file paper form to your local municipal assessor. BAR appeal: submit 10 copies + supporting docs to County BAR Office (142 Federal St, Portland) and one to municipal assessor."
      noticeOfValueMailed="June"
      noticeOfValueMailedDateExplanation="Preliminary valuation notices have been mailed in June in some counties, with new valuations taking effect in September. These are only sent in revaluation years which occur every three years. Check with local assessor office."
      valuationAsOfDate="April 1"
      valuationAsOfDateExplanation="Property values based on their condition as of April 1 (36 Maine Revised Statutes § 502). This unique assessment date differs from most states and captures spring market conditions."
      deadlineExplanation="Property owners have either 185 days after commitment or within 60 days of receiving bill (36 Maine Revised Statutes § 841). The deadline varies based on when the tax bill is received, but October is typically the deadline for most properties."
    />
  );
};

export default Maine;